'use client';

import { XIcon } from 'lucide-react';
import type { OfferDocument } from 'models/offer';
import { Montserrat } from 'next/font/google';
import { useAuth } from 'context/AuthContext';
import AcceptOfferContent from './AcceptOfferContent';
import DeclineOfferContent from './DeclineOfferContent';
import CounterOfferContent from './CounterOfferContent';

const montserrat = Montserrat({ subsets: ['latin'] });

export interface OfferOperationContentProps {
  type: 'counter' | 'accept' | 'decline';
  offer: OfferDocument;
  onClose: () => void;
  hideCloseButton?: boolean;
  showTitle?: boolean;
}

export default function OfferOperationContent({
  type,
  offer,
  onClose,
  hideCloseButton = false,
  showTitle = true,
}: OfferOperationContentProps) {
  const { userDoc } = useAuth();
  const isSeller = offer.seller_id === userDoc?.uid;

  return (
    <div className={montserrat.className}>
      {showTitle && (
        <div className="flex w-full items-center justify-between border-b border-zinc-200 p-8">
          <div className="flex-grow text-center">
            <h1 className="text-[2.4rem] font-bold capitalize text-zinc-900">
              {type} Offer
            </h1>
          </div>

          {!hideCloseButton && (
            <button type="button" onClick={onClose} className="text-zinc-700">
              <XIcon />
            </button>
          )}
        </div>
      )}

      {type === 'accept' && (
        <AcceptOfferContent
          offer={offer}
          onClose={onClose}
          isSeller={isSeller}
        />
      )}

      {type === 'decline' && (
        <DeclineOfferContent offer={offer} onClose={onClose} />
      )}

      {type === 'counter' && (
        <CounterOfferContent offer={offer} onClose={onClose} />
      )}
    </div>
  );
}
